import * as React from 'react';


const baseStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: 1280,
  marginInline: 'auto',
  padding: '32px 32px 56px',
  boxSizing: 'border-box',
  animation: 'fadeUp 360ms cubic-bezier(0.16, 1, 0.3, 1) both',
};

export class MainPadding extends React.PureComponent<any> {
  render() {
    const { style, ...rest } = this.props;
    return (
      <div
        style={{ ...baseStyle, ...style }}
        {...rest}
      />
    );
  }
}
